import React, { useState, useEffect } from "react";
import { residentApi } from "../fetchers";

function TableEditRow({ id, setEditRowId, data, refetch }) {
  const [editObj, setEditObj] = useState(data);

  const handleInput = (e, target) => {
    setEditObj((prev) => {
      return {
        ...prev,
        [target]: e.target.value,
      };
    });
  };

  const handleSelectChange = (e, target) => {
    if (target === "owner") {
      if (e === false) {
        setEditObj((prev) => {
          return {
            ...prev,
            isOwner: 0,
          };
        });
      } else if (e === true) {
        setEditObj((prev) => {
          return {
            ...prev,
            isOwner: 1,
          };
        });
      }
    } else if (target === "resident") {
      if (e === false) {
        setEditObj((prev) => {
          return {
            ...prev,
            isResident: 0,
          };
        });
      } else if (e === true) {
        setEditObj((prev) => {
          return {
            ...prev,
            isResident: 1,
          };
        });
      }
    }
  };

  const handleCancelButton = () => {
    setEditRowId(null);
  };

  const handleModify = async (data) => {
    if (window.confirm("수정하시겠습니까?")) {
      const modifyResponse = await residentApi.modify(id, data);
      if (modifyResponse.data) {
        alert("저장되었습니다");
        setEditRowId(null);
        refetch();
      } else if (modifyResponse.error) {
        alert(modifyResponse.error.message);
      }
    }
  };

  useEffect(() => {
    if (editObj.hasOwnProperty("birthDate") && editObj.birthDate.length === 8) {
      setEditObj((prev) => {
        return {
          ...prev,
          birthDate: editObj.birthDate
            .replace(/-/g, "")
            .replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3"),
        };
      });
    }
  }, [editObj.birthDate]);

  useEffect(() => {
    if (editObj.hasOwnProperty("phone") && editObj.phone.length === 10) {
      setEditObj((prev) => {
        return {
          ...prev,
          phone: editObj.phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"),
        };
      });
    } else if (editObj.hasOwnProperty("phone") && editObj.phone.length === 13) {
      setEditObj((prev) => {
        return {
          ...prev,
          phone: editObj.phone
            .replace(/-/g, "")
            .replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3"),
        };
      });
    }
  }, [editObj.phone]);

  return (
    <tr className={"row mx-0 align-items-center border-bottom"}>
      <td className={"list-group-item border-0"} style={{ width: "55px" }}></td>
      <td className={"list-group-item border-0"} style={{ width: "90px" }}>
        <input
          className="form-control text-center"
          placeholder="동"
          type="num"
          onChange={(e) => handleInput(e, "dong")}
          value={editObj.dong}
        />
      </td>
      <td className={"list-group-item border-0"} style={{ width: "90px" }}>
        <input
          className="form-control text-center"
          placeholder="호"
          onChange={(e) => handleInput(e, "ho")}
          value={editObj.ho}
        />
      </td>
      <td className={"list-group-item border-0"} style={{ width: "130px" }}>
        <input
          className="form-control text-center"
          placeholder="이름"
          onChange={(e) => handleInput(e, "name")}
          value={editObj.name}
        />
      </td>
      <td className={"list-group-item border-0"} style={{ width: "150px" }}>
        <input
          className="form-control text-center"
          placeholder="1990-00-00"
          onChange={(e) => handleInput(e, "birthDate")}
          value={editObj.birthDate || ""}
          maxLength={10}
        />
      </td>
      <td className={"list-group-item border-0"} style={{ width: "180px" }}>
        <input
          className="form-control text-center"
          placeholder="010-0000-0000"
          onChange={(e) => handleInput(e, "phone")}
          value={editObj.phone || ""}
          maxLength={13}
        />
      </td>

      <td className={"list-group-item border-0"} style={{ width: "90px" }}></td>
      <td
        className={"list-group-item border-0 text-center"}
        style={{ width: "90px" }}
      >
        <input
          type="checkbox"
          onChange={(e) => handleSelectChange(e.target.checked, "owner")}
          checked={editObj.isOwner == 1 ? true : false}
        />
      </td>
      <td
        className={"list-group-item border-0 text-center"}
        style={{ width: "90px" }}
      >
        <input
          type="checkbox"
          onChange={(e) => handleSelectChange(e.target.checked, "resident")}
          checked={editObj.isResident == 1 ? true : false}
        />
      </td>
      <td
        className={"list-group-item border-0 text-center"}
        style={{ width: "150px" }}
      >
        <span className="cursor-pointer" onClick={handleCancelButton}>
          취소
        </span>
        <span
          className="cursor-pointer text-primary ml-3"
          onClick={() => handleModify(editObj)}
        >
          저장
        </span>
      </td>
    </tr>
  );
}

export default TableEditRow;
